import React from "react";
import { Container, Typography, Toolbar, AppBar, Box, Divider } from "@mui/material";
import Atras from "./atras";
import BottomNav from "./BottomNav";

const sections = [
  {
    title: "1. Información que recopilamos",
    body: "Recopilamos información que usted nos proporciona directamente al registrarse, como nombre, dirección de correo electrónico, teléfono, profesión, ubicación y foto de perfil. También recopilamos su ubicación geográfica en tiempo real mientras usa la aplicación, exclusivamente para mostrarle en el mapa a otros usuarios y viceversa.",
  },
  {
    title: "2. Uso de la información",
    body: "Utilizamos la información recopilada para: (a) mostrar su perfil profesional a otros usuarios de FindMe; (b) mostrar su ubicación en el mapa en tiempo real; (c) permitir que otros usuarios le contacten; (d) mejorar y personalizar la experiencia dentro de la aplicación; (e) enviarte comunicaciones relacionadas con el servicio.",
  },
  {
    title: "3. Compartir información",
    body: "FindMe no vende, alquila ni comercializa su información personal a terceros. Su nombre, profesión, foto de perfil y ubicación en tiempo real son visibles para otros usuarios registrados de la plataforma. Usted puede actualizar o eliminar su información en cualquier momento desde la sección de edición de perfil.",
  },
  {
    title: "4. Ubicación en tiempo real",
    body: "La aplicación solicita acceso a su ubicación GPS para mostrarle en el mapa. Esta información se almacena temporalmente en nuestros servidores mientras la sesión esté activa. Al cerrar sesión, su ubicación deja de ser visible para otros usuarios. Puede revocar el permiso de ubicación desde la configuración de su dispositivo en cualquier momento.",
  },
  {
    title: "5. Seguridad de los datos",
    body: "Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Usamos Firebase de Google como infraestructura de backend, que cuenta con certificaciones de seguridad reconocidas internacionalmente.",
  },
  {
    title: "6. Retención de datos",
    body: "Conservamos su información personal mientras su cuenta esté activa. Si decide eliminar su cuenta, sus datos personales serán eliminados de nuestros servidores en un plazo de 30 días, salvo que la ley exija su conservación por un período mayor.",
  },
  {
    title: "7. Derechos del usuario",
    body: "Usted tiene derecho a acceder, rectificar y eliminar sus datos personales. También puede oponerse al tratamiento de sus datos o solicitar su portabilidad. Para ejercer estos derechos, puede contactarnos a través de los canales indicados al final de este documento.",
  },
  {
    title: "8. Cookies y tecnologías similares",
    body: "FindMe puede utilizar tecnologías de almacenamiento local (localStorage, sessionStorage) para mantener su sesión activa y mejorar la experiencia de uso. No utilizamos cookies de rastreo publicitario de terceros.",
  },
  {
    title: "9. Cambios en esta política",
    body: "Podemos actualizar esta Política de Privacidad periódicamente. Le notificaremos sobre cambios significativos mediante una notificación dentro de la aplicación o por correo electrónico. Le recomendamos revisar esta política regularmente.",
  },
  {
    title: "10. Contacto",
    body: "Si tiene preguntas o inquietudes sobre esta Política de Privacidad, puede contactarnos en: soporte@findme.app",
  },
];

const Privacy = () => {
  return (
    <Container maxWidth="md">
      <AppBar position="fixed" elevation={0} sx={{ background: "rgba(8,11,20,0.88)", backdropFilter: "blur(24px)", WebkitBackdropFilter: "blur(24px)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
        <Toolbar sx={{ flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "10px" }}>
          <Atras color="inherit" />
          <Container sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", width: "100%", height: "90px", marginTop: "10px" }}>
            <Typography variant="h5" color="white" gutterBottom>
              Política y Privacidad
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
      <Box sx={{ mt: "140px", mb: 14, px: 1 }}>
        <Box sx={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 4, p: 3, mb: 3 }}>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.55)", fontStyle: "italic" }}>
            Última actualización: marzo de 2026
          </Typography>
          <Typography variant="body1" sx={{ color: "rgba(185,205,255,0.8)", mt: 1, lineHeight: 1.8 }}>
            En FindMe nos comprometemos a proteger su privacidad. Esta política describe cómo recopilamos, usamos y protegemos su información personal cuando utiliza nuestra aplicación.
          </Typography>
        </Box>
        {sections.map((s, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#00d4ff", mb: 0.8 }}>
              {s.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(185,205,255,0.75)", lineHeight: 1.9 }}>
              {s.body}
            </Typography>
            {i < sections.length - 1 && <Divider sx={{ mt: 2.5, borderColor: "rgba(255,255,255,0.06)" }} />}
          </Box>
        ))}
      </Box>
      <BottomNav />
    </Container>
  );
};

export default Privacy;
